import React from 'react';
import { Control, useFormState, useWatch } from 'react-hook-form';
import i18n from '../../../utils/i18n';
import { IconEnum } from '../../../ui/Icon';
import ImagesUploadSingle from '../../../components/ImagesUpload/imagesUploadSingle';
import { FileUploadType } from '../../../components/ImagesUpload/types';
import Details from '../../../ui/Details/details';
import { ICategoryForm } from '../types';
import { filesNameSimple } from '../../../utils/fetch/filesNames';
import { getCategoryImgSrc } from '../../../utils/url';
import GridRow from '../../../ui/GridRow';
import GridCol from '../../../ui/GridCol';

interface IImagesUploadCategory {
    control: Control<ICategoryForm>;
}

const IMAGE_FIELD = 'img';

const ImagesUploadCategory = ({ control }: IImagesUploadCategory) => {
    const categoryName = useWatch({ name: 'name', control });

    const { errors } = useFormState({
        control,
        name: IMAGE_FIELD,
        exact: true,
    });

    const hasError = errors[IMAGE_FIELD];

    return (
        <Details label={i18n.general.images} icon={IconEnum.IMAGE} error={!!hasError}>
            <GridRow gutter={8}>
                <GridCol col={6}>
                    <GridRow column gutter={8}>
                        <p>
                            <b>{i18n.category.mainImage}</b>
                        </p>
                        <ImagesUploadSingle
                            type={FileUploadType.CATEGORY}
                            srcHandler={getCategoryImgSrc}
                            name={IMAGE_FIELD}
                            control={control}
                            fileName={filesNameSimple(categoryName)}
                        />
                    </GridRow>
                </GridCol>
            </GridRow>
        </Details>
    );
};

export default ImagesUploadCategory;
